import { OurContext } from '../context';
import { ERRORS } from './errors';
import { networkPollingAndRetry, OptionalErrorResponseTuple } from './util';

export interface PaymentOrderDetails {
  merchantName: string;
  amount: {
    currency: string;
    value: number;
    displayValue: string;
  };
  returnUrl: string;
  expireTime: number;
  peToken: string;
}

export async function abortCardPayment(context: OurContext): Promise<Response | undefined> {
  return context.epaymentApi
    .abortCardPaymentRaw({
      ocpApimSubscriptionKey: context.epaymentApiSubscriptionId,
    })
    .then((r) => r.raw);
}

export async function getEpaymentDetails(
  context: OurContext
): Promise<OptionalErrorResponseTuple<PaymentOrderDetails>> {
  try {
    const [err, response] = await networkPollingAndRetry(
      () =>
        context.epaymentApi.getPaymentDetails({
          ocpApimSubscriptionKey: context.epaymentApiSubscriptionId,
        }),
      3
    );
    if (err || !response) {
      return [err || new Error(ERRORS.NETWORK_ISSUE), null];
    }
    const currency = response.transaction?.amount?.currency || 'NOK';
    const value = response.transaction.amount.value;

    const displayValue = new Intl.NumberFormat(context.locale, {
      currencyDisplay: 'code',
      style: 'currency',
      currency,
    }).format((value / 100).toFixed(2) as unknown as number);

    return [
      null,
      {
        merchantName: response.merchant.name,
        amount: {
          currency,
          value,
          displayValue,
        },
        returnUrl: response.transaction.returnUrl,
        expireTime: response.expireTime,
        peToken: response.peToken,
      },
    ];
  } catch (e) {
    return [e as Error, null];
  }
}
